import { isTouchDevice } from 'js/utils/Utils'
import { roundEx } from 'js/utils/Maths'
import { deepMerge } from 'js/utils/Utils'

const defaults = {
  breakPoint: {
    default: 1920,
    mobile: 767,
  },
  browserName: {
    chrome: 'chrome',
    safari: 'safari',
    edge: 'edge',
    opera: 'opera',
    firefox: 'firefox',
    uaClientHints: {
      chrome: 'Google Chrome',
      edge: 'Microsoft Edge',
      opera: 'Opera',
    },
    others: 'others',
  },
  attrName: {
    os: {
      key: 'data-os',
      value: {
        win: 'win',
        mac: 'mac',
      },
    },
    browser: {
      key: 'data-browser',
      value: {
        chrome: 'chrome',
        safari: 'safari',
        edge: 'edge',
        opera: 'opera',
        firefox: 'firefox',
        others: 'others',
      },
    },
    device: {
      key: 'data-device',
      value: {
        default: 'default',
        mobile: 'mobile',
        tablet: 'tablet',
      },
    },
    pointingDevice: {
      key: 'data-pointing-device',
      value: {
        mouse: 'mouse',
        touch: 'touch',
      },
    },
    layout: {
      key: 'data-layout',
      value: {
        default: 'default',
        mobile: 'mobile',
      },
    },
    darkTheme: {
      key: 'data-dark-theme',
      value: {
        default: 'default',
        dark: 'dark',
      },
    },
    usingWebgl: {
      key: 'data-use-webgl',
    },
    usingInlineVideo: {
      key: 'data-use-inline-video',
    },
    dpr: {
      key: 'data-window-dpr',
    },
  },
}

export default class DetectionManager {
  constructor(options = {}) {
    deepMerge(this, defaults, options)

    this.$html = document.documentElement

    this.browser = this.checkBrowser()

    this.isTouchDevice = this.checkIsTouchDevice()
    this.isMobileLayout = this.checkIsMobileLayout()
    this.isMobileDevice = this.checkIsMobileDevice()
    this.isTabletDevice = this.checkIsTabletDevice()

    this.checkDevice()
    this.setDPR()

    this.useWebgl = this.checkUseWebgl()
    // this.useInlineVideo = this.checkUseInlineVideo()
    // this.isDarkMode = this.checkIsDarkMode()
  }

  checkBrowser() {
    let browser = this.browserName.others
    const uaData = window.navigator.userAgentData

    if (uaData) {
      // browser
      const brands = uaData.brands

      if (brands && brands.length) {
        brands.forEach((brandsItem) => {
          const brand = brandsItem.brand

          // TODO 2022.03時でUA-CH対応ブラウザはChrome, MS Edge, Operaのみ
          switch (true) {
            case brand.indexOf(this.browserName.uaClientHints.chrome) !== -1:
              browser = this.attrName.browser.value.chrome
              break

            case brand.indexOf(this.browserName.uaClientHints.edge) !== -1:
              browser = this.attrName.browser.value.edge
              break

            case brand.indexOf(this.browserName.uaClientHints.opera) !== -1:
              browser = this.attrName.browser.value.opera
              break

            default:
              break
          }

          if (this.$html) {
            this.$html.setAttribute(this.attrName.browser.key, browser)
          }
        })
      } else {
        let ua = window.navigator.userAgent
        if (ua) {
          ua = ua.toLowerCase()
          const isIOS = /iphone|ipod|ipad/.test(ua)

          switch (true) {
            case ua.match(/(msie|trident)/):
              browser = this.attrName.browser.value.ie
              break

            // iOS Firefox (FxiOS)
            case isIOS && ua.includes('fxios'):
              browser = this.attrName.browser.value.firefox
              break

            // iOS Chrome (CriOS)
            case isIOS && ua.includes('crios'):
              browser = this.attrName.browser.value.chrome
              break

            // iOS Edge (EdgiOS)
            case isIOS && ua.includes('edgios'):
              browser = this.attrName.browser.value.edge
              break

            // iOS Safari (Version/X.X + Safari)
            case isIOS && ua.includes('safari') && ua.includes('version'):
              browser = this.attrName.browser.value.safari
              break

            // Android / PC Chrome
            case ua.includes('chrome'):
              browser = this.attrName.browser.value.chrome
              break

            // Android / PC Firefox
            case ua.includes('firefox'):
              browser = this.attrName.browser.value.firefox
              break

            // PC Safari
            case ua.includes('safari'):
              browser = this.attrName.browser.value.safari
              break

            case ua.includes('opera'):
              browser = this.attrName.browser.value.opera
              break

            case ua.includes('edge'):
              browser = this.attrName.browser.value.edge
              break

            default:
              break
          }

          if (this.$html) {
            this.$html.setAttribute(this.attrName.browser.key, browser)
          }
        }
      }
    } else {
      let ua = window.navigator.userAgent
      if (ua) {
        ua = ua.toLowerCase()
        const isIOS = /iphone|ipod|ipad/.test(ua)

        switch (true) {
          case ua.match(/(msie|trident)/):
            browser = this.attrName.browser.value.ie
            break

          // iOS Firefox (FxiOS)
          case isIOS && ua.includes('fxios'):
            browser = this.attrName.browser.value.firefox
            break

          // iOS Chrome (CriOS)
          case isIOS && ua.includes('crios'):
            browser = this.attrName.browser.value.chrome
            break

          // iOS Edge (EdgiOS)
          case isIOS && ua.includes('edgios'):
            browser = this.attrName.browser.value.edge
            break

          // iOS Safari (Version/X.X + Safari)
          case isIOS && ua.includes('safari') && ua.includes('version'):
            browser = this.attrName.browser.value.safari
            break

          // Android / PC Chrome
          case ua.includes('chrome'):
            browser = this.attrName.browser.value.chrome
            break

          // Android / PC Firefox
          case ua.includes('firefox'):
            browser = this.attrName.browser.value.firefox
            break

          // PC Safari
          case ua.includes('safari'):
            browser = this.attrName.browser.value.safari
            break

          case ua.includes('opera'):
            browser = this.attrName.browser.value.opera
            break

          case ua.includes('edge'):
            browser = this.attrName.browser.value.edge
            break

          default:
            break
        }

        if (this.$html) {
          this.$html.setAttribute(this.attrName.browser.key, browser)
        }

        // if (ua.match(/(msie|MSIE)/) || ua.match(/(T|t)rident/)) {
        //   browser = 'ie'
        // } else if (ua.indexOf('chrome') !== -1) {
        //   browser = this.attrName.browser.value.chrome
        // } else if (ua.indexOf('safari') !== -1) {
        //   browser = this.attrName.browser.value.safari
        // } else if (ua.indexOf('opera') !== -1) {
        //   browser = this.attrName.browser.value.opera
        // } else if (ua.indexOf('firefox') !== -1) {
        //   browser = this.attrName.browser.value.firefox
        // } else if (ua.indexOf('edge') !== -1) {
        //   browser = this.attrName.browser.value.edge
        // }
      }
    }
    return browser
  }

  checkIsTouchDevice() {
    const isTD = isTouchDevice()
    if (this.$html) {
      if (isTD) {
        this.$html.setAttribute(this.attrName.pointingDevice.key, this.attrName.pointingDevice.value.touch)
      } else {
        this.$html.setAttribute(this.attrName.pointingDevice.key, this.attrName.pointingDevice.value.mouse)
      }
    }

    return isTD
  }

  checkIsMobileLayout() {
    const isML = document.body.clientWidth <= this.breakPoint.mobile
    if (this.$html) {
      if (isML) {
        this.$html.setAttribute(this.attrName.layout.key, this.attrName.layout.value.mobile)
      } else {
        this.$html.setAttribute(this.attrName.layout.key, this.attrName.layout.value.default)
      }
    }

    return isML
  }

  checkIsMobileDevice() {
    return this.isMobileLayout && this.isTouchDevice
  }

  checkIsTabletDevice() {
    const ua = navigator.userAgent.toLowerCase()
    const isWindows = ua.includes('windows')
    return !this.isMobileLayout && this.isTouchDevice && !isWindows
  }

  checkDevice() {
    if (this.$html) {
      if (this.isMobileDevice) {
        this.$html.setAttribute(this.attrName.device.key, this.attrName.device.value.mobile)
      } else if (this.isTabletDevice) {
        this.$html.setAttribute(this.attrName.device.key, this.attrName.device.value.tablet)
      } else {
        this.$html.setAttribute(this.attrName.device.key, this.attrName.device.value.default)
      }
    }
  }

  /**
   * プロジェクトによって内容を変更する
   * @returns {boolean}
   */
  checkUseWebgl() {
    const useGl = !this.isTouchDevice && !this.isMobileLayout
    if (useGl) {
      this.$html.setAttribute(this.attrName.usingWebgl.key, 'true')
    } else {
      this.$html.setAttribute(this.attrName.usingWebgl.key, 'false')
    }

    return useGl
  }

  /**
   * プロジェクトによって内容を変更する
   * @returns {boolean}
   */
  checkUseInlineVideo() {
    // const useIV = !this.isTouchDevice && !this.isMobileLayout
    const useIV = !this.isMobileLayout
    // const useIV = true

    if (useIV) {
      this.$html.setAttribute(this.attrName.usingInlineVideo.key, 'true')
    } else {
      this.$html.setAttribute(this.attrName.usingInlineVideo.key, 'false')
    }

    return useIV
    // return true
  }

  checkIsDarkMode() {
    const isDM = window.matchMedia('(prefers-color-scheme: dark)').matches
    if (this.$html) {
      if (isDM) {
        this.$html.setAttribute(this.attrName.darkTheme.key, this.attrName.darkTheme.value.dark)
      } else {
        this.$html.setAttribute(this.attrName.darkTheme.key, this.attrName.darkTheme.value.default)
      }
    }

    return isDM
  }

  setDPR() {
    const dpr = roundEx(window.devicePixelRatio, 1000)

    if (this.$html) {
      this.$html.setAttribute(this.attrName.dpr.key, dpr)
    }
  }
}